import { createActions, createReducer } from "reduxsauce";

//Action types e Creators
export const { Types, Creators } = createActions({
	tagsClean: [],
	getTagsSuccess: [],
	getTagsError: [],
	getTagsLoading: [],
    setTagToast: []
});

//Reducer Handlers
const INITIAL_STATE = {
    tags: [],
    error: undefined,
    loading: false,
    tagToast: {
        showToast: false,
        message: '',
        messageType: 'toast-success'
    },
};

const clean = (state = INITIAL_STATE, action) => {
    return { ...INITIAL_STATE };
};

const change = (state = INITIAL_STATE, action) => {
    return { ...INITIAL_STATE, tags: action.tags };
};

const error = (state = INITIAL_STATE, action) => {
    return { ...INITIAL_STATE, error: action.error };
};

const loading = (state = INITIAL_STATE, action) => {
    return { ...INITIAL_STATE, loading: action.payload };
};

const setTagToast = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        tagToast: {
            showToast: action.payload.showToast,
            message: action.payload.message,
            messageType: action.payload.messageType
        }
    };
}

//Criando Reducer
export default createReducer(INITIAL_STATE, {
    [Types.TAGS_CLEAN]: clean,
    [Types.GET_TAGS_SUCCESS]: change,
    [Types.GET_TAGS_ERROR]: error,
    [Types.GET_TAGS_LOADING]: loading,
    [Types.SET_TAG_TOAST]: setTagToast,
});